import { FieldEvaluationResultError } from '@/modules/decisioning-criteria/types';
import { SpecialCombinedTprmFieldName } from '@/modules/entity-details/models/SpecialCombinedTprmFieldName.model';
import {
    SpecialCombinedTprmFieldTypeName,
} from '@/modules/entity-details/models/SpecialCombinedTprmFieldTypeName.model';

function getCombineCommonNameTypeFieldError(
    fieldName: string,
    fieldType: string,
    evaluationErrors: Record<string, FieldEvaluationResultError>,
): FieldEvaluationResultError | null {
    const nameError = evaluationErrors[fieldName];
    const typeError = evaluationErrors[fieldType];
    if (!nameError && !typeError) {
        return null;
    }
    const nameMsg = nameError?.messages || [];
    const typeMsg = typeError?.messages || [];
    return { ...typeError, ...nameError, messages: [ ...nameMsg, ...typeMsg ] };
}

function combineAdditionalInsuredError(
    idPrefix: string,
    evaluationErrors: Record<string, FieldEvaluationResultError>,
): FieldEvaluationResultError | null {
    const nameKey = `${idPrefix}${SpecialCombinedTprmFieldName.additionalInsured}`;
    const typeKey = `${idPrefix}${SpecialCombinedTprmFieldTypeName.additionalInsuredType}`;
    return getCombineCommonNameTypeFieldError(
        nameKey,
        typeKey,
        evaluationErrors,
    );
}

function combineWosCompanyNameError(
    idPrefix: string,
    evaluationErrors: Record<string, FieldEvaluationResultError>,
): FieldEvaluationResultError | null {
    const nameKey = `${idPrefix}${SpecialCombinedTprmFieldName.waiverOfSubrogationCompanyName}`;
    const typeKey = `${idPrefix}${SpecialCombinedTprmFieldTypeName.waiverOfSubrogationCompanyNameType}`;
    return getCombineCommonNameTypeFieldError(
        nameKey,
        typeKey,
        evaluationErrors,
    );
}

type GetCombinedErrorFunction =
    (fieldId: string, errorMap: Record<string, FieldEvaluationResultError>) => FieldEvaluationResultError | null;
const fieldFunctionMap: Record<SpecialCombinedTprmFieldName, GetCombinedErrorFunction> = {
    [SpecialCombinedTprmFieldName.additionalInsured]: combineAdditionalInsuredError,
    [SpecialCombinedTprmFieldName.waiverOfSubrogationCompanyName]: combineWosCompanyNameError,
};

export function getEvaluationErrorWithCombinedFields(
    fieldId: string,
    evaluationErrors: Record<string, FieldEvaluationResultError>,
): FieldEvaluationResultError | null {
    const fieldName = fieldId.split('/').pop();
    const prefix = fieldId.replace(new RegExp(/\w+$/gm), '');
    for (const [ key, getter ] of Object.entries(fieldFunctionMap)) {
        if (fieldName === key) {
            return getter(prefix, evaluationErrors);
        }
    }
    return evaluationErrors[fieldId] || null;
}
